import styled from 'styled-components'

export const ViewToggleContainer = styled.div`
  display: flex;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

export const ViewToggleButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${(props) => (props.$active ? '#00ade6' : '#ffffff')};
  color: ${(props) => (props.$active ? 'white' : '#6b6b6b')};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  min-width: 80px;
  justify-content: center;

  &:hover {
    background: ${(props) => (props.$active ? '#00a1d6' : '#f5f5f5')};
    color: ${(props) => (props.$active ? 'white' : '#1a1a1a')};
  }

  &:focus {
    outline: none;
    box-shadow: inset 0 0 0 2px rgba(0, 173, 230, 0.3);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  @media (max-width: 768px) {
    padding: 6px 10px;
    font-size: 11px;
    min-width: 40px;
    gap: 4px;
  }
`

export const ViewToggleIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;
    stroke-width: 2;

    @media (max-width: 768px) {
      width: 12px;
      height: 12px;
    }
  }
`

export const ViewToggleLabel = styled.span`
  @media (max-width: 480px) {
    display: none;
  }
`
